/**
 * @generated SignedSource<<1833c065688f6bb34b75afb2d9d56e55>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type walletManageFilesDialog_ClearMutation$variables = {
  slug: string;
};
export type walletManageFilesDialog_ClearMutation$data = {
  readonly walletUploadsClear: {
    readonly cleared: number;
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
  } | null | undefined;
};
export type walletManageFilesDialog_ClearMutation = {
  response: walletManageFilesDialog_ClearMutation$data;
  variables: walletManageFilesDialog_ClearMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cleared",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "walletManageFilesDialog_ClearMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "WalletUploadsClearMutationPayload",
        "kind": "LinkedField",
        "name": "walletUploadsClear",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "walletManageFilesDialog_ClearMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "WalletUploadsClearMutationPayload",
        "kind": "LinkedField",
        "name": "walletUploadsClear",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9203f1600ab62f18f0f3350458e63534",
    "id": null,
    "metadata": {},
    "name": "walletManageFilesDialog_ClearMutation",
    "operationKind": "mutation",
    "text": "mutation walletManageFilesDialog_ClearMutation(\n  $slug: String!\n) {\n  walletUploadsClear(slug: $slug) {\n    cleared\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a385393b0181cedb3c482c1d8412c6ea";

export default node;
